import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const WheelDrive = ({ wheelDrive }: SpecProps<"wheel_drive">) => {
  const { i18n } = useLingui();

  if (!wheelDrive) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.wheel_drive",
    message: "Wheel drive",
    comment: "Field for 'wheel drive' in ad specification",
  });
  return <FieldValuePair field={field} value={wheelDrive} />;
};
